import { EvaluationState } from 'src/modules/evaluation/types/EvaluationState';
import { RootState } from 'src/types/RootState';

export function getEvaluationState(state: RootState): EvaluationState {
  return state.evaluation;
}
